<template>
  <div class="settings-page">
    <div class="settings-card" v-loading="loading">
      <h3>系统设置</h3>
      <p class="settings-desc">配置小程序端的展示内容</p>

      <div class="setting-group">
        <h4>咨询页设置</h4>
        <div class="form-item">
          <label>二维码图片 <span class="size-hint">1:1</span></label>
          <div class="upload-area">
            <div v-if="form.qrcode_url" class="image-preview qrcode-preview">
              <img :src="form.qrcode_url" alt="二维码" />
              <button class="btn-remove-img" @click="form.qrcode_url = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('qrcodeInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="qrcodeInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'qrcode_url')" />
          </div>
          <input v-model="form.qrcode_url" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>咨询页背景图</label>
          <div class="upload-area">
            <div v-if="form.apply_bg_image" class="image-preview bg-preview">
              <img :src="form.apply_bg_image" alt="背景图" />
              <button class="btn-remove-img" @click="form.apply_bg_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('bgInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="bgInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'apply_bg_image')" />
          </div>
          <input v-model="form.apply_bg_image" type="text" placeholder="或输入图片URL地址" />
        </div>
      </div>

      <div class="setting-group">
        <h4>首页分享设置</h4>
        <div class="form-item">
          <label>分享好友图片 <span class="size-hint">5:4</span></label>
          <div class="upload-area">
            <div v-if="form.home_share_friend_image" class="image-preview friend-preview">
              <img :src="form.home_share_friend_image" alt="好友分享图" />
              <button class="btn-remove-img" @click="form.home_share_friend_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('homeFriendInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="homeFriendInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'home_share_friend_image')" />
          </div>
          <input v-model="form.home_share_friend_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享朋友圈图片 <span class="size-hint">1:1</span></label>
          <div class="upload-area">
            <div v-if="form.home_share_timeline_image" class="image-preview timeline-preview">
              <img :src="form.home_share_timeline_image" alt="朋友圈分享图" />
              <button class="btn-remove-img" @click="form.home_share_timeline_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('homeTimelineInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="homeTimelineInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'home_share_timeline_image')" />
          </div>
          <input v-model="form.home_share_timeline_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享标题</label>
          <input v-model="form.home_share_title" type="text" placeholder="首页分享时的标题文字" />
        </div>
      </div>

      <div class="setting-group">
        <h4>咨询页分享设置</h4>
        <div class="form-item">
          <label>分享好友图片 <span class="size-hint">5:4</span></label>
          <div class="upload-area">
            <div v-if="form.consult_share_friend_image" class="image-preview friend-preview">
              <img :src="form.consult_share_friend_image" alt="好友分享图" />
              <button class="btn-remove-img" @click="form.consult_share_friend_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('consultFriendInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="consultFriendInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'consult_share_friend_image')" />
          </div>
          <input v-model="form.consult_share_friend_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享朋友圈图片 <span class="size-hint">1:1</span></label>
          <div class="upload-area">
            <div v-if="form.consult_share_timeline_image" class="image-preview timeline-preview">
              <img :src="form.consult_share_timeline_image" alt="朋友圈分享图" />
              <button class="btn-remove-img" @click="form.consult_share_timeline_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('consultTimelineInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="consultTimelineInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'consult_share_timeline_image')" />
          </div>
          <input v-model="form.consult_share_timeline_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享标题</label>
          <input v-model="form.consult_share_title" type="text" placeholder="咨询页分享时的标题文字" />
        </div>
      </div>

      <div class="setting-group">
        <h4>单品列表分享设置</h4>
        <div class="form-item">
          <label>分享好友图片 <span class="size-hint">5:4</span></label>
          <div class="upload-area">
            <div v-if="form.product_share_friend_image" class="image-preview friend-preview">
              <img :src="form.product_share_friend_image" alt="好友分享图" />
              <button class="btn-remove-img" @click="form.product_share_friend_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('productFriendInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="productFriendInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'product_share_friend_image')" />
          </div>
          <input v-model="form.product_share_friend_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享朋友圈图片 <span class="size-hint">1:1</span></label>
          <div class="upload-area">
            <div v-if="form.product_share_timeline_image" class="image-preview timeline-preview">
              <img :src="form.product_share_timeline_image" alt="朋友圈分享图" />
              <button class="btn-remove-img" @click="form.product_share_timeline_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('productTimelineInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="productTimelineInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'product_share_timeline_image')" />
          </div>
          <input v-model="form.product_share_timeline_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享标题</label>
          <input v-model="form.product_share_title" type="text" placeholder="单品列表分享时的标题文字" />
        </div>
      </div>

      <div class="setting-group">
        <h4>免费专区分享设置</h4>
        <div class="form-item">
          <label>分享好友图片 <span class="size-hint">5:4</span></label>
          <div class="upload-area">
            <div v-if="form.free_share_friend_image" class="image-preview friend-preview">
              <img :src="form.free_share_friend_image" alt="好友分享图" />
              <button class="btn-remove-img" @click="form.free_share_friend_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('freeFriendInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="freeFriendInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'free_share_friend_image')" />
          </div>
          <input v-model="form.free_share_friend_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享朋友圈图片 <span class="size-hint">1:1</span></label>
          <div class="upload-area">
            <div v-if="form.free_share_timeline_image" class="image-preview timeline-preview">
              <img :src="form.free_share_timeline_image" alt="朋友圈分享图" />
              <button class="btn-remove-img" @click="form.free_share_timeline_image = ''">移除</button>
            </div>
            <div v-else class="upload-trigger" @click="triggerUpload('freeTimelineInput')">
              <span class="upload-icon">+</span>
              <span>点击上传</span>
            </div>
            <input ref="freeTimelineInput" type="file" accept="image/*" style="display:none" @change="handleUpload($event, 'free_share_timeline_image')" />
          </div>
          <input v-model="form.free_share_timeline_image" type="text" placeholder="或输入图片URL地址" />
        </div>
        <div class="form-item">
          <label>分享标题</label>
          <input v-model="form.free_share_title" type="text" placeholder="免费专区分享时的标题文字" />
        </div>
      </div>

      <div class="setting-group">
        <h4>站点信息</h4>
        <div class="form-item">
          <label>站点名称</label>
          <input v-model="form.site_name" type="text" placeholder="小程序名称" />
        </div>
        <div class="form-item">
          <label>API 基础地址（小程序端）</label>
          <input v-model="form.api_base_url" type="text" placeholder="http://your-domain.com/server/api" />
        </div>
      </div>

      <div class="setting-group">
        <h4>显示控制</h4>
        <div class="form-item toggle-item">
          <span class="toggle-label">首页显示文章主标题</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="form.show_main_title" true-value="1" false-value="0" />
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="form-item toggle-item">
          <span class="toggle-label">首页分类栏显示"全部"标签</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="form.show_category_all_tab" true-value="1" false-value="0" />
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="form-item toggle-item">
          <span class="toggle-label">文章详情页显示底部购买按钮</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="form.show_bottom_bar" true-value="1" false-value="0" />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>

      <div class="setting-group">
        <h4>咨询弹窗设置</h4>
        <div class="form-item">
          <label>弹窗提示文字</label>
          <input v-model="form.modal_qrcode_tip" type="text" placeholder="长按识别添加老师，快速咨询" />
        </div>
        <div class="form-item">
          <label>弹窗底部提示文字</label>
          <input v-model="form.modal_qrcode_subtip" type="text" placeholder="若无法保存，可截屏后添加" />
        </div>
        <div class="form-item">
          <label>弹窗微信号文字</label>
          <input v-model="form.modal_wechat_id" type="text" placeholder="【微信号：stypanda】" />
        </div>
      </div>

      <div class="form-actions">
        <button class="btn-primary" @click="handleSave" :disabled="saving">
          {{ saving ? '保存中...' : '保存设置' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { request, BASE_URL } from '../api/index';

export default {
  name: 'Settings',
  data() {
    return {
      form: {
        qrcode_url: '',
        apply_bg_image: '',
        home_share_friend_image: '',
        home_share_timeline_image: '',
        home_share_title: '',
        consult_share_friend_image: '',
        consult_share_timeline_image: '',
        consult_share_title: '',
        product_share_friend_image: '',
        product_share_timeline_image: '',
        product_share_title: '',
        free_share_friend_image: '',
        free_share_timeline_image: '',
        free_share_title: '',
        site_name: '',
        api_base_url: '',
        show_main_title: '1',
        show_category_all_tab: '1',
        show_bottom_bar: '1',
        modal_qrcode_tip: '',
        modal_qrcode_subtip: '',
        modal_wechat_id: '',
      },
      loading: false,
      saving: false,
    };
  },
  async created() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      this.loading = true;
      try {
        const res = await request('/settings.php');
        const data = res.data;
        if (data) {
          this.form.qrcode_url = data.qrcode_url || '';
          this.form.apply_bg_image = data.apply_bg_image || '';
          this.form.home_share_friend_image = data.home_share_friend_image || '';
          this.form.home_share_timeline_image = data.home_share_timeline_image || '';
          this.form.home_share_title = data.home_share_title || '';
          this.form.consult_share_friend_image = data.consult_share_friend_image || '';
          this.form.consult_share_timeline_image = data.consult_share_timeline_image || '';
          this.form.consult_share_title = data.consult_share_title || '';
          this.form.product_share_friend_image = data.product_share_friend_image || '';
          this.form.product_share_timeline_image = data.product_share_timeline_image || '';
          this.form.product_share_title = data.product_share_title || '';
          this.form.free_share_friend_image = data.free_share_friend_image || '';
          this.form.free_share_timeline_image = data.free_share_timeline_image || '';
          this.form.free_share_title = data.free_share_title || '';
          this.form.site_name = data.site_name || '';
          this.form.api_base_url = data.api_base_url || '';
          this.form.show_main_title = data.show_main_title || '1';
          this.form.show_category_all_tab = data.show_category_all_tab || '1';
          this.form.show_bottom_bar = data.show_bottom_bar || '1';
        this.form.modal_qrcode_tip = data.modal_qrcode_tip || '';
        this.form.modal_qrcode_subtip = data.modal_qrcode_subtip || '';
        this.form.modal_wechat_id = data.modal_wechat_id || '';
        }
      } catch (e) {
        alert('加载设置失败: ' + e.message);
      } finally {
        this.loading = false;
      }
    },
    async handleSave() {
      this.saving = true;
      try {
        await request('/settings.php', {
          method: 'POST',
          body: this.form,
        });
        alert('保存成功');
      } catch (e) {
        alert('保存失败: ' + e.message);
      } finally {
        this.saving = false;
      }
    },
    triggerUpload(refName) {
      this.$refs[refName].click();
    },
    async handleUpload(e, field) {
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      try {
        var token = localStorage.getItem('admin_token');
        var res = await fetch(BASE_URL + '/upload.php', {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + token },
          body: formData,
        });
        var data = await res.json();
        if (data.code === 0) {
          this.form[field] = data.data.url;
        } else {
          alert('上传失败: ' + data.msg);
        }
      } catch (err) {
        alert('上传失败: ' + err.message);
      }
    },
  },
};
</script>

<style scoped>
.settings-page {
  max-width: 700px;
}

.settings-card {
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.settings-card h3 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.settings-desc {
  font-size: 13px;
  color: #999;
  margin-bottom: 24px;
}

.setting-group {
  margin-bottom: 28px;
}

.setting-group h4 {
  font-size: 15px;
  font-weight: 500;
  color: #555;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-item {
  margin-bottom: 14px;
}

.form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #666;
}

.form-item input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.form-item input:focus {
  border-color: #1677FF;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

.form-actions {
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}

.toggle-label {
  font-size: 14px;
  color: #333;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  cursor: pointer;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #d9d9d9;
  border-radius: 12px;
  transition: 0.3s;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  left: 2px; top: 2px;
  width: 20px; height: 20px;
  background: #fff;
  border-radius: 50%;
  transition: 0.3s;
}

.toggle-switch input:checked + .toggle-slider {
  background: #1677FF;
}

.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(20px);
}

.btn-primary {
  height: 38px;
  padding: 0 24px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary:hover {
  background: #4096ff;
}

.btn-primary:disabled {
  background: #a0c4ff;
  cursor: not-allowed;
}

.upload-area {
  margin-bottom: 8px;
}

.upload-trigger {
  width: 160px;
  height: 100px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  transition: border-color 0.3s;
}

.upload-trigger:hover {
  border-color: #1677FF;
  color: #1677FF;
}

.upload-icon {
  font-size: 28px;
  line-height: 1;
  margin-bottom: 4px;
}

.size-hint {
  font-size: 11px;
  color: #bbb;
  font-weight: 400;
  margin-left: 8px;
}

.image-preview {
  position: relative;
  display: inline-block;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.image-preview img {
  object-fit: cover;
  display: block;
}

.friend-preview img {
  width: 200px;
  height: 160px;
}

.timeline-preview img {
  width: 160px;
  height: 160px;
}

.qrcode-preview img {
  width: 160px;
  height: 160px;
}

.bg-preview img {
  width: 320px;
  height: 200px;
}

.btn-remove-img {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}
</style>
